export default __webpack_public_path__ + "assets/audios/a1c221fb449725181ab2d24b228bd17d.mp3";